import React from 'react'
import { labelMappings } from '../utils/utils'

function CouponConfigurableLabel({text,className,style}:{text:string,className?:string,style?:object}) {
  const str = labelMappings[text]??text;
  return (
    <label className={`coupon-configurable-label ${className}` } style={style}>{str}</label>
  )
}

export default CouponConfigurableLabel